import { useEffect, useState } from "react";
import withLoader from "../../../components/layouts/WithLoader";
import UtilsFormule from "../../../utils/UtilsFormule";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import DiscountService from "../../../services/DiscountService";
import { useNavigate } from "react-router-dom";

const ListConditionsCommercialsB2B = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();

  const [availableConditionsCommercial, setAvailableConditionsCommercial] =
    useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  useEffect(() => {
    startLoading();
    DiscountService.allConditionsCommercialTiers(getCurrentUserId(), 1, 0)
      .then((response) => {
        if (response.data.success) {
          setAvailableConditionsCommercial(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in allDiscounts", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  const onAddHandler = () => {
    navigate(`/addConditionCommercial`);
  };

  const onArchiveHandler = (id, deleted) => {
    startLoading();
    DiscountService.archiveConditionCommercial(id, deleted)
      .then((response) => {
        if (response.data.success) {
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          setTimeout(() => {
            navigate(`/conditionscommercials`);
          }, 2000);
        } 
      })
      .catch((e) => {
        console.log("error in allDiscounts", e);
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : "+e);
      })
      .finally(() => {
        stopLoading();
      });
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Les conditions commercials</h5>
                  <button
                    class="btn btn-dark float-right"
                    data-toggle="modal"
                    data-target="#add-brand"
                    onClick={onAddHandler}
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <section class="content">
            <div class="card">
              <div class="card-header  ">
                <h3 class="card-title">Les conditions commercials</h3>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                    title="Collapse"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                </div>
              </div>
              <div class="card-body p-0">
                <table class="table  projects">
                  <thead>
                    <tr>
                      <th>Libellé</th>
                      <th>description</th>
                      <th style={{ width: "12%" }}>Active</th>

                      <th style={{ width: "12%" }}>Date début</th>
                      <th style={{ width: "12%" }}>Date fin</th>

                      <th className="text-center" style={{ width: "12%" }}>
                        Archiver
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {availableConditionsCommercial &&
                      availableConditionsCommercial.map((element, i) => (
                        <tr key={element.id}>
                          <td>
                            {element.refCC}-{element.nameCC}
                          </td>
                          <td>{element.descriptionCC}</td>

                          {element.isActive === 1 ? (
                            <td className="text-center">Active</td>
                          ) : (
                            <td className="text-center">Non active</td>
                          )}

                          <td>{UtilsFormule.formatDate(element.startDate)}</td>
                          <td>{UtilsFormule.formatDate(element.endDate)}</td>

                          <td className="text-center">
                            <button
                              style={{ width: 40 }}
                              class="btn btn-danger btn-sm"
                              onClick={() => onArchiveHandler(element.id, 1)}
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
export default withLoader(ListConditionsCommercialsB2B);
